<!-- eslint-disable -->
<template lang="pug">
    div.generator-form
        div.generator-form__divider
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameList_commentToTask')")
            cs-input(v-model="selectedGame.text")
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_mode')")
            cs-multiselect(
                :multiple="false",
                :options="modes",
                :show-labels="false",
                :allow-empty="false",
                placeholder="",
                v-model="selectedMode",
                @select="selectedGame.parameters.mode = $event.value",
                track-by="name",
                label="name"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_difficulty')")
            cs-multiselect(
                :multiple="false",
                :options="difficult",
                :show-labels="false",
                :allow-empty="false",
                placeholder="",
                v-model="selectedDifficult",
                @select="difficultHandler",
                track-by="name",
                label="name"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_numOfActions')")
            cs-select.generator-form__select(
                v-model="selectedGame.parameters.amountOfActions",
                :firstNumber="2",
                :options="actions",
                placeholder=""
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_numOfExamples')")
            cs-select.generator-form__select(
                v-model="selectedGame.parameters.amountOfExamples",
                :options="examples",
                placeholder=""
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_jumpOver50')")
            cs-checkbox.generator-form__checkbox(
                v-model="selectedGame.parameters.jumpOver50"
                :disabled="!isAllowJumpOver"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_jumpOver100')")
            cs-checkbox.generator-form__checkbox(
                v-model="selectedGame.parameters.jumpOver100"
                :disabled="!isAllowJumpOver"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_fractions')")
            cs-checkbox.generator-form__checkbox(
                :checked="selectedGame.parameters.fractions"
                @change="fractionsHandler"
                :disabled="fractionsDisabled"
            )
        form-group.generator-form__form-group(
            v-if="selectedGame.parameters.fractions",
            :label="$i18n.t('trainer.trainer_gameFormSetting_numbersAfterPoints')"
        )
            cs-select.generator-form__select(
                v-model="selectedGame.parameters.fractionalPart",
                :options="fractionalParts",
                placeholder=""
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_mirror')")
            cs-checkbox.generator-form__checkbox(
                v-model="selectedGame.parameters.mirror",
                :disabled="mirrorDisabled"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_roundNumbers')")
            cs-checkbox.generator-form__checkbox(
                :checked="selectedGame.parameters.roundNumbers",
                @change="roundNumbersHandler"
                :disabled="roundNumbersDisabled"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_combiningNumOfDigits')")
            cs-checkbox.generator-form__checkbox(
                :checked="selectedGame.parameters.combining",
                :disabled="combiningDisabled"
                @change="combiningHandler"
            )
        form-group.generator-form__form-group(v-if="selectedGame.parameters.combining && !selectedGame.parameters.roundNumbers && !selectedGame.parameters.fractions", label=" ")
            div.generator-form__numbers-container
                combining-digit-capacities(
                    :combiningDigitCapacityLabels="combiningDigitCapacityLabels",
                    :filteredCombiningDigitCapacities="filteredCombiningDigitCapacities",
                    :combiningDigitCapacities="selectedGame.parameters.combiningDigitCapacities",
                    @changeCombiningDigitCapacities="changeCombiningDigitCapacities"
                )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_positiveAnswers')")
            cs-checkbox.generator-form__checkbox(
                v-model="selectedGame.parameters.positiveAnswers",
                :disabled="positiveAnswersDisabled"
            )
        form-group.generator-form__form-group(:label="$i18n.t('trainer.trainer_gameFormSetting_negativeAnswers')")
            cs-checkbox.generator-form__checkbox(
                v-model="selectedGame.parameters.negativeAnswers",
                :disabled="negativeAnswersDisabled"
            )
</template>

<script>
    /*eslint-disable*/
    import _ from "lodash"
    import combiningCapacitiesMixin from './utils/combiningCapacitiesMixin'
    import CombiningDigitCapacities from './shared/CombiningDigitCapacity.vue'

    export default {
        components: {
            CombiningDigitCapacities
        },
        props: {
            selectedGame: Object
        },
        mixins: [combiningCapacitiesMixin],
        data() {
            return {
                modes: [
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbacus'),
                        value: 'abacus'
                    },
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_inMind'),
                        value: 'mind'
                    },
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSettingValue_any'),
                        value: 'any'
                    },
                ],
                difficult: [
                    {
                        name: this.$i18n.t('common.common_gameSetting_singleDigitNum'),
                        value: 1
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        value: 2
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        value: 3
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        value: 4
                    },
                    {
                        name: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                        value: 5
                    },
                    {
                        value: 6,
                        name: this.$i18n.t('common.common_gameSetting_sixDigitsNum')
                    },
                    {
                        value: 7,
                        name: this.$i18n.t('common.common_gameSetting_sevenDigitsNum')
                    },
                    {
                        value: 8,
                        name: this.$i18n.t('common.common_gameSetting_eightDigitsNum')
                    }
                ],
                examples: 100,
                actions: 25,
                fractionalParts: 2,
                jumpOver: [50, 100],
                selectedDifficult: null,
                selectedMode: null,
                combiningDigitCapacities: [1, 2, 3, 4, 5, 6, 7, 8],
                combiningDigitCapacityLabels: {
                    1: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                    2: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                    3: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                    4: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                    5: this.$i18n.t('common.common_gameSetting_digitCapacity5'),
                    6: this.$i18n.t('common.common_gameSetting_digitCapacity6'),
                    7: this.$i18n.t('common.common_gameSetting_digitCapacity7'),
                    8: this.$i18n.t('common.common_gameSetting_digitCapacity8')
                }
            }
        },
        watch: {
            mirrorDisabled(val) {
                if (val) {
                    this.selectedGame.parameters.mirror = false;
                }
            },
            combiningDisabled(val) {
                if (val) {
                    this.selectedGame.parameters.combining = false;
                }
            },
            roundNumbersDisabled(val) {
                if (val) {
                    this.selectedGame.parameters.roundNumbers = false;
                }
            },
            isAllowJumpOver(val) {
                if (!val) {
                    this.selectedGame.parameters.jumpOver50 = false;
                    this.selectedGame.parameters.jumpOver100 = false;
                }
            }
        },
        mounted() {
            this.selectedDifficult = _.find(this.difficult, {value: this.selectedGame.parameters.difficult});
            this.selectedMode = _.find(this.modes, {value: this.selectedGame.parameters.mode});
        },
        computed: {
            isAllowJumpOver() {
                return this.selectedGame.parameters
                    && !this.selectedGame.parameters.combining
                    && !this.selectedGame.parameters.mirror
                    && !this.selectedGame.parameters.roundNumbers
                    && !this.selectedGame.parameters.fractions
                    && (this.selectedGame.parameters.difficult === 2
                        || this.selectedGame.parameters.difficult === 3)
            },
            positiveAnswersDisabled() {
                return this.selectedGame.parameters.positiveAnswers && !this.selectedGame.parameters.negativeAnswers;
            },
            negativeAnswersDisabled() {
                return this.selectedGame.parameters.negativeAnswers && !this.selectedGame.parameters.positiveAnswers;
            },
            mirrorDisabled() {
                return this.selectedGame.parameters.difficult === 1
                    || this.selectedGame.parameters.fractions
                    || this.selectedGame.parameters.roundNumbers
                    || this.selectedGame.parameters.jumpOver50
                    || this.selectedGame.parameters.jumpOver100
                    || this.selectedGame.parameters.combining;
            },
            roundNumbersDisabled() {
                return this.selectedGame.parameters.difficult === 1
                    || this.selectedGame.parameters.fractions
                    || this.selectedGame.parameters.mirror
                    || this.selectedGame.parameters.jumpOver50
                    || this.selectedGame.parameters.jumpOver100;
            },
            fractionsDisabled() {
                return this.selectedGame.parameters.roundNumbers
                    || this.selectedGame.parameters.mirror
                    || this.selectedGame.parameters.jumpOver50
                    || this.selectedGame.parameters.jumpOver100;
            },
            combiningDisabled() {
                return this.selectedGame.parameters
                    && (
                        (this.selectedGame.parameters.difficult === 1 || this.selectedGame.parameters.mirror)
                        || (this.selectedGame.parameters.difficult === 2 && this.selectedGame.parameters.roundNumbers)
                        || this.selectedGame.parameters.jumpOver50
                        || this.selectedGame.parameters.jumpOver100
                    );
            }
        },
        methods: {
            combiningHandler(combining) {
                this.selectedGame.parameters.combining = combining;
                this.selectedGame.parameters.combiningDigitCapacities = [];
                if (combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            difficultHandler(difficult) {
                this.selectedGame.parameters.difficult = difficult.value;
                if (this.selectedGame.parameters.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            roundNumbersHandler(roundNumbers) {
                this.selectedGame.parameters.roundNumbers = roundNumbers;
                if (this.selectedGame.parameters.combining) {
                    this.fillCombiningDigitCapacities();
                }
            },
            fractionsHandler(fractions) {
                this.selectedGame.parameters.fractions = fractions;
                if (this.selectedGame.parameters.combining) {
                    this.fillCombiningDigitCapacities();
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .generator-form {
        @include stack-space($space-large);

        &__divider {
            @include stack-space($space-base);
            border-bottom: 1px solid $color-grey-300;
        }

        &__select {
            width: 100%;
        }

        &__form-group {
            @include stack-space($space-base);
        }

        &__checkbox-container {
            @include stack-space($space-large);
            display: flex;
            padding-top: $space-x-small;
        }

        &__checkbox {
            @include inline-space($space-base);
        }
    }
</style>
